import { useContext } from "react"
import { AuthenticationContext } from "../AuthenticationContext"
import MyCompanyPageContent from "../components/MyCompany/MyCompanyPageContent"
import { TenantsContextWrapper } from "../components/MyTenant/TenantsContext"
import { TenantImageUrls } from "../components/MyTenant/tenantsModel"

type Props = {
  heroImage: string
}

const MyCompanyPage = ({ heroImage }: Props) => {
  const { currentUser } = useContext(AuthenticationContext)
  const serverTenantImages: TenantImageUrls = {
    customer: `${currentUser?.tenant.publicFolderUrl}/images/default-customer.jpg`,
    item: `${currentUser?.tenant.publicFolderUrl}/images/default-item.jpg`,
    logo: `${currentUser?.tenant.publicFolderUrl}/images/logo.png`,
    projects: `${currentUser?.tenant.publicFolderUrl}/images/default-projects.jpg`,
    property: `${currentUser?.tenant.publicFolderUrl}/images/default-property.jpg`,
    template: `${currentUser?.tenant.publicFolderUrl}/images/default-template.jpg`,
    setup: `${currentUser?.tenant.publicFolderUrl}/images/default-setup.jpg`
  }

  return <TenantsContextWrapper 
    tenantId={currentUser?.tenant.id}
    imagesData={serverTenantImages}
  >
    <MyCompanyPageContent heroImage={heroImage} />
  </TenantsContextWrapper>
}

export default MyCompanyPage